import { render, staticRenderFns } from "./WidgetCheckbox.vue?vue&type=template&id=ce0b9e56"
import script from "./WidgetCheckbox.vue?vue&type=script&lang=js"
export * from "./WidgetCheckbox.vue?vue&type=script&lang=js"
import style0 from "./WidgetCheckbox.vue?vue&type=style&index=0&id=ce0b9e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports